import React, {useState, useEffect} from "react";
import {
    Box,
    Heading,
    Text,
    VStack,
    Button,
    useColorModeValue,
    chakra, useToast
} from "@chakra-ui/react";

import {Header as Nav} from "../header/Header";
import {Footer} from "../footer/Footer";
import {ROUTE_MAIN, ROUTE_PARAM_ORDER, ROUTE_PURCHASE} from "../../App";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";

import {
    getHashByOrderId,
    usePageNotFoundToast,
    checkIfHashExistsInCookies,
    PAYMENT_CARD
} from "../../infrastructure/utils/formUtils";
import OrderDetailDataProvider from "../dataProviderEvo/order-detail-data-provider";

import {PurchaseConfirmation, BankInfo} from "./PurchaseConfirmation";

export const PAYMENT_STATE_PAYED = 2;
export const PAYMENT_STATE_CANCELED = 3;
export const PAYMENT_STATE_PENDING = 1;
export const PAYMENT_STATE_REFUNDED = 4;


export const PaymentByCardStates = ({ outcome }) => {

    const [orderData, setOrderData] = useState([]);
    const [basketHash, setBasketHash] = useState(null);
    const [title, setTItle] = useState('');
    const [message, setMessage] = useState('');
    const [buttonText, setButtonText] = useState('');
    const [buttonAction, setButtonAction] = useState('');
    const [outcomeContent, setOutcomeContent] = useState({});

    let navigate = useNavigate();
    let toast = useToast();
    const { id, refId } = useParams();


    useEffect(() => {

        if (!id || !refId) {
            navigate(ROUTE_MAIN, { replace: true }); // Replace history to avoid back navigation

            toast({
                description: 'Stránka, kterou hledáte, neexistuje, nebo k ní nemáte přístup.',
                status: 'info',
                duration: 3000, // Doba zobrazení toastu v milisekundách
                isClosable: true, // Uživatel může toast zavřít
                position: 'top',
            });
        }


        let orderId  = checkIfHashExistsInCookies(refId);
        orderId = 3;
        if(!orderId) {
            navigate(ROUTE_MAIN, {replace: true});
        } else {
            setBasketHash(refId);
        }

    }, [id, refId, navigate]);


    useEffect(() => {
        if(basketHash && Object.keys(orderData).length  == 0) {
            let dp = new OrderDetailDataProvider();
            dp.getData(refId, {}, {}).then((res) => {
                if (res && res.status === 'OK') {

                    if(res.data.payment_method.code != PAYMENT_CARD){

                        navigate(ROUTE_MAIN);

                        toast({
                            description: 'Stránka, kterou hledáte, neexistuje, nebo k ní nemáte přístup.',
                            status: 'info',
                            duration: 5000,
                            isClosable: true,
                            position: 'top',
                        });

                    } else {
                        setOrderData(res.data);
                    }
                } else {
                    toast({
                        title: 'Při načítání objednavky došlo k potížím',
                        description: res.errors[0],
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });
                }

            });
        }
    }, [basketHash]);

    useEffect(() => {
        if (Object.keys(orderData).length > 1) {
            let buttonTextVar = '',
                buttonActionVar = '',
                message = '';

            if (orderData.payment_gateway_payment.state.code == PAYMENT_STATE_PAYED) {
                buttonTextVar = "Zpět na hlavní stránku";
                buttonActionVar = ROUTE_MAIN;
                message = '';
            } else if (orderData.payment_gateway_payment.state.code == PAYMENT_STATE_CANCELED) {
                buttonTextVar = "Zaplatit kartou";
                buttonActionVar = orderData.payment_gateway_payment.redirect_url;
                message = <Text>{orderData.payment_gateway_payment.state.value}</Text>;
            } else if (orderData.payment_gateway_payment.state.code == PAYMENT_STATE_PENDING) {
                buttonTextVar = "Zpět na hlavní stránku";
                buttonActionVar = ROUTE_MAIN;
                message = <Text>{orderData.payment_gateway_payment.state.value}</Text>;
            } else {
                buttonTextVar = "Zpět na hlavní stránku";
                buttonActionVar = ROUTE_MAIN;
                message = <Text>{orderData.payment_gateway_payment?.state?.value}</Text>;
            }

            let content = {
                title: 'Objednávka předplatného',
                message: (
                    <Box p={4}>
                        {message}
                    </Box>
                ),
                buttonText: buttonTextVar,
                buttonAction: buttonActionVar
            };

            setOutcomeContent(content);
        }
    }, [orderData]);

    useEffect(() => {
        if(Object.keys(outcomeContent).length  > 1) {
            setTItle(outcomeContent.title);
            setMessage(outcomeContent.message);
            setButtonText(outcomeContent.buttonText);
            setButtonAction(outcomeContent.buttonAction);
        }
    }, [outcomeContent]);

    return (
        <Box
            bg={useColorModeValue('#f9f9f9', '#1a202c')}
            height="100vh"
            justifyContent="center"
            alignItems="center"
        >
            <Nav />

            {Object.keys(outcomeContent).length  > 1 && (
                <>
                <chakra.h1 textAlign={'center'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                    {title}
                </chakra.h1>

                {basketHash && (<PurchaseConfirmation innerContentOnly={true} orderHashParam={basketHash} showBankTransferInfo={true} showMenu={false}/>)}

                <Box
                    width="100%"
                    maxW="800px"
                    mx="auto"
                    bg="white"
                    borderRadius="lg"
                    paddingBottom={10}
                    paddingLeft={10}
                    paddingRight={10}
                    boxShadow="md"
                    mb={"50px"}
                >
                    <VStack spacing={6}>
                        <Text textAlign="center" fontSize="lg">
                            {message}
                        </Text>

                        <Button as="a"
                            size="lg"
                            colorScheme="pink"
                            href={buttonAction}
                        >
                            {buttonText}
                        </Button>
                    </VStack>
                </Box>

                {Object.keys(orderData).length > 0 && (orderData.payment_gateway_payment.state.code  == PAYMENT_STATE_CANCELED || orderData.payment_gateway_payment.state.code  == PAYMENT_STATE_PENDING) && (<Box
                    width="100%"
                    maxW="800px"
                    mx="auto"
                    bg="white"
                    borderRadius="lg"
                    padding={10}
                    boxShadow="md"
                    mb={"50px"}
                >
                    <chakra.h2 textAlign={'center'} fontSize={'3xl'} py={10} fontWeight={'bold'}>
                        {"Zaplatit bankovním převodem"}
                    </chakra.h2>
                    <BankInfo orderData={orderData} />
                </Box>)}
                </>
            )}

            <Footer />
        </Box>
    );
};


export const PayedMsg = () => {
    return ( <Box>
        <Heading as="h2" size="lg" mb={4}>Vaše předplatné bylo úspěšně zaplaceno</Heading>
        <Text mb={4}>Na e-mailovou adresu jsme Vám zaslali potvrzení o platbě.</Text>
        <Text>
            <strong>Pro nové čtenáře:</strong>
            <br />
            Při objednávce jsme pro Vás automaticky vytvořili účet čtenáře. Přihlašovací údaje naleznete ve Vašem e-mailu.
        </Text>
    </Box>)

}

